import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { TextBox } from "../core/components/textBox.js";
import { Button } from "../core/components/button.js";
import { FieldInstance } from "../core/components/field.js";
import { Helper } from "../core/util/helper.js";
import { Config } from "../core/config/config.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { BaseComponentProps } from "../core/components/baseComponentProps.js";
import React from "react"
import ReactDOM from "react-dom";
interface ContainerFilterDropDownProps extends BaseComponentProps {
    value: number;
    onChange: (field: { model: string }, value: number, dataItem?: any) => void;
    beforeDialogOpen?: () => Promise<void>;
    afterDialogClose?: () => Promise<void>;
    onError?: (error, info) => void
}

export default class ContainerFilterDropDown extends React.Component<ContainerFilterDropDownProps, { filters: { Key, Value }[] }> {
    private factory = ComponentHelper.createFactory();
    private appInitialized = false;

    constructor(props) {
        super(props)
        this.state = {
            filters: []
        }
    }

    private loadFilters = async () => {
        const filters = await HTTPService.get<JsonResultClass>("ContainerFilter/GetAll");
        this.appInitialized = true;
        this.setState({ filters: filters.Data })
    }

    private renderButtons = () => {
        const buttons = [
            <div title={Helper.getTranslation("Standard.Neu")} key={"0"} >
                <Button
                    handleClick={async () => {
                        const filter: Filter = {
                            Id: (this.state.filters.length == 0 ? 0 : Math.max(...this.state.filters.map(f => f.Key))) + 1,
                            Items: [],
                            Name: ""
                        };
                        const saved = await this.openFilter(filter)
                        if (saved) {
                            this.props.value
                        }
                    }}
                    iconName={"plus"}
                />
            </div>
        ];

        if (Helper.hasValue(this.props.value) && this.appInitialized) {
            buttons.unshift(<div title={Helper.getTranslation("Standard.Editieren")} key={"1"}>
                <Button
                    handleClick={async () => {
                        const filter = await HTTPService.get<JsonResultClass>(`ContainerFilter/GetById?id=${this.props.value}`);
                        await this.openFilter(filter.Data);

                    }}
                    iconName={"pen"}
                />
            </div>);

            buttons.unshift(<div title={Helper.getTranslation("Standard.Loeschen")} key={"2"}>
                <Button
                    handleClick={async () => {
                        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
                        if (!isOk)
                            return;
                        const result = await HTTPService.get<JsonResultClass>(`ContainerFilter/Delete?id=${this.props.value}`);
                        if (result.Code == 0) {
                            this.props.onChange(this.props.field, null);
                            await this.loadFilters();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    }}
                    iconName={"trash-alt"}
                />
            </div>);
        }
        return <div className={"container-filter-dropDown__buttons"}>{buttons}</div>;
    }

    componentDidMount() {
        this.loadFilters();
    }

    private beforeDialogOpen = async () => {
        if (Helper.hasValue(this.props.beforeDialogOpen)) {
            await this.props.beforeDialogOpen();
        } else {
            return;
        }
    }

    private afterDialogClose = async () => {
        if (Helper.hasValue(this.props.afterDialogClose)) {
            await this.props.afterDialogClose();
        } else {
            return;
        }
    }

    private openFilter = (filter: Filter) => {
        return new Promise<boolean>(async (resolve) => {
            await this.beforeDialogOpen();
            const saved = await this.editFilter(filter);
            await this.loadFilters();
            await this.afterDialogClose();
            resolve(saved);
        })
    }

    private editFilter = (filter: Filter) => {
        return new Promise<boolean>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            let dialogRef: EditFilterDialog;
            const close = async (saved) => {
                if (Helper.hasValue(dialogRef)) {
                    dialogRef.close();
                    resolve(saved);
                }
            }

            const root = ReactDOM["createRoot"](targetElement[0]);
            root.render(
                <>
                    <EditFilterDialog
                        filter={filter}
                        validate={this.validateFilter}
                        close={close}
                        ref={(ref) => { dialogRef = ref }}
                        onError={this.props.onError}
                    />
                </>
            );
        })
    }

    private validateFilter = async (filter: Filter) => {
        if (Helper.isNullOrEmpty(filter.Name)) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.EmptyName"));
            return false;
        }


        if (this.state.filters.findIndex(f => f.Key != filter.Id && f.Value == filter.Name) != -1) {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.NameEmptySaveAnyway"));
            if (!isOk)
                return false;
        }

        if (filter.Items.length == 0) {
            const isOk = await DialogHelper.confirm(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.NoItems"));
            if (!isOk)
                return false;
        }
        return true;
    }

    render() {
        const filters = JSON.parse(JSON.stringify(this.state.filters));
        filters.unshift({ Key: null, Value: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.NoFilterSelcted") });
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = !this.appInitialized;
        props.dataSource = filters;
        props.value = this.props.value;
        props.field.refreshDSOnRefChange = true;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.optionLabel = "";
        props.onChange = (_, value: string | number, dataItem) => {
            switch (typeof value) {
                case "number":
                    this.props.onChange(this.props.field, value, dataItem);
                    break;
                case "string":
                default:
                    this.props.onChange(this.props.field, null, null);
                    break;
            }
        }
        props.onDataLoaded = () => { }
        return (
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                {this.renderButtons()}
                <div style={{ flex: "1", alignSelf: "center", marginRight: "10px" }} >
                    <DropDownList {...props} />
                </div>
            </div>
        );
    }

}

interface EditFilterDialogProps {
    filter: Filter;
    validate: (filter: Filter) => Promise<boolean>;
    close: (saved: boolean) => void;
    onError: (error, info) => void
}

class EditFilterDialog extends React.Component<EditFilterDialogProps, { filter: Filter }>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: "",
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.close(false);
                }
            },
            {
                label: Helper.getTranslation("Standard.Speichern"),
                action: () => {
                    this.props.validate(this.state.filter).then((isOk) => {
                        if (isOk) {
                            this.saveFilter();
                        }
                    });
                    return false;
                },
                primary: true
            }
        ],
        width: 600
    };
    private dialogRef: Dialog;

    constructor(props) {
        super(props)
        this.state = {
            filter: this.props.filter
        }
    }

    close = () => {
        this.dialogRef.close();
    }

    private saveFilter = async () => {
        const result = await HTTPService.post<JsonResultClass>("ContainerFilter/Save", {
            filter: this.state.filter
        })
        if (result.Code == 0) {
            this.props.close(true);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private renderTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.filter.Name;
        props.field.maxLength = 12;
        props.onChange = (_, name) => {
            const filter = this.state.filter;
            filter.Name = name;
            this.setState({ filter: filter })
        }
        return (
            <FieldInstance label={Helper.getTranslation("Standard.Name")}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    componentDidCatch(error, info) {
        if (Helper.hasValue(this.props.onError)) {
            this.props.onError(error, info);
        }
    }

    render() {
        return (
            <>
                <Dialog {...this.dialogProps} open={true} title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.EditFilter")} ref={(ref) => { this.dialogRef = ref }} >
                    {this.renderTextBox()}
                    <ListBox selected={this.state.filter.Items} onChange={(items) => {
                        const filter = this.state.filter;
                        filter.Items = items;
                        this.setState({ filter: filter })
                    }} />
                </Dialog>
            </>
        );
    }
}

interface Filter {
    Id: number;
    Name: string;
    Items: FilterItem[]
}

interface IContainsGrNr {
    GrNr: number;
}

interface FilterItem extends IContainsGrNr {
    Sort: number;
}

interface GroupItem extends IContainsGrNr {
    Bezeichnung: string
}

interface ListBoxProps {
    selected: FilterItem[];
    onChange: (items: FilterItem[]) => void;
}

class ListBox extends React.Component<ListBoxProps, { hash: number }> {
    private availableListBoxId = kendo.guid();
    private selectedListBoxId = kendo.guid();

    private availableListBox: kendo.ui.ListBox;
    private selectedListBox: kendo.ui.ListBox;

    private availableListBoxRef: HTMLSelectElement;
    private selectedListBoxRef: HTMLSelectElement;

    private groups: GroupItem[] = [];
    private gruppenNachNamenSortieren: boolean = false;

    constructor(props) {
        super(props)
        this.state = {
            hash: 0,
        }
    }

    private onItemsChange = (items: FilterItem[]) => {
        items = items.map((item, index) => {
            return {
                GrNr: item.GrNr,
                Sort: index + 1
            }
        }).filter(this.onlyUnique);
        this.props.onChange(JSON.parse(JSON.stringify(items)))
    }

    private loadGroups = async () => {
        const result = await HTTPService.get<JsonResultClass<GroupItem[]>>("ContainerFilter/GetGroups");
        this.groups = result.Data;
        this.gruppenNachNamenSortieren = result.AdditionalData["GruppenNachNamenSortieren"];
        this.setDataSources();
    }

    private setDataSources = () => {
        this.availableListBox.setDataSource(new kendo.data.DataSource({
            data: this.groups
                .filter(item => this.props.selected.findIndex(selected => selected.GrNr == item.GrNr) == -1)
                .filter(this.onlyUnique)
                .sort(this.sort)
        }));

        this.selectedListBox.setDataSource(new kendo.data.DataSource({
            data: this.props.selected.map(item => {
                const grNr = item.GrNr;
                const group = this.groups.find(g => g.GrNr == grNr);
                const bezeichnung = Helper.hasValue(group) ? group.Bezeichnung : grNr;
                return {
                    GrNr: grNr,
                    Bezeichnung: bezeichnung
                }
            }).filter(this.onlyUnique),
        }));

    }

    private onlyUnique = (value: IContainsGrNr, index: number, self: IContainsGrNr[]) => {
        return self.findIndex(item => item.GrNr == value.GrNr) === index;
    }

    private sort = (a: GroupItem, b: GroupItem) => {
        const sortingField = this.gruppenNachNamenSortieren ? "Bezeichnung" : "GrNr";

        if (a[sortingField] > b[sortingField]) {
            return 1;
        }
        if (a[sortingField] < b[sortingField]) {
            return -1;
        }
        return 0;
    }

    componentDidUpdate() {
        const hash = Helper.getHashCode(JSON.stringify(this.props.selected));
        if (this.state.hash != hash) {
            const sGrNr = this.getSelectedGrNr(this.selectedListBox);
            const oGrNr = this.getSelectedGrNr(this.availableListBox)
            this.setState({ hash: hash }, () => {
                this.setDataSources();
                this.selectGrNr(this.selectedListBox, sGrNr)
                this.selectGrNr(this.availableListBox, oGrNr);
            })
        }
    }

    componentWillUnmount() {
        kendo.destroy(this.availableListBoxRef);
        this.availableListBox.destroy();
        kendo.destroy(this.selectedListBoxRef);
        this.selectedListBox.destroy();
    }

    componentDidMount() {
        this.availableListBox = $(this.availableListBoxRef).kendoListBox({
            draggable: false,
            dataTextField: "Bezeichnung",
            dataValueField: "GrNr",
            connectWith: this.selectedListBoxId,
            dropSources: [this.selectedListBoxId],
            toolbar: {
                tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]

            }
        }).data("kendoListBox");

        this.selectedListBox = $(this.selectedListBoxRef).kendoListBox({
            draggable: false,
            dataTextField: "Bezeichnung",
            dataValueField: "GrNr",
            connectWith: this.availableListBoxId,
            dropSources: [this.availableListBoxId],
            toolbar: {
                tools: ["moveUp", "moveDown"]
            },
            remove: (e) => {
                const removeGrNrs: number[] = e.dataItems.map(item => item.GrNr)
                const items = this.props.selected.filter(item => removeGrNrs.findIndex(grNr => grNr == item.GrNr) == -1);
                this.onItemsChange(items)
            },
            add: (e) => {
                const items = this.props.selected;
                const dataItems: GroupItem[] = e.dataItems;
                dataItems.forEach((item: any) => {
                    items.push({
                        GrNr: item.GrNr,
                        Sort: -1
                    });
                })
                this.onItemsChange(items);
            },
            reorder: (e) => {
                const offset = e.offset;
                const movedGrNr = e.dataItems[0].GrNr;

                const items = this.props.selected;
                const index = items.findIndex(item => item.GrNr == movedGrNr)

                items[index].GrNr = items[index + offset].GrNr;
                items[index + offset].GrNr = movedGrNr;

                this.onItemsChange(items);
            }

        }).data("kendoListBox");

        this.loadGroups();
    }

    private getSelectedGrNr = (listBox: kendo.ui.ListBox) => {
        const uid = listBox.select().attr("id");
        const tmp = listBox.dataItems().find((item: any) => item.uid == uid)
        return Helper.hasValue(tmp) ? tmp.GrNr : null;
    }

    private selectGrNr = (listBox: kendo.ui.ListBox, grNr: number) => {
        const tmp = listBox.dataItems().find((item: IContainsGrNr) => item.GrNr == grNr);
        if (Helper.hasValue(tmp)) {
            const uid = tmp.uid;
            const item = listBox.wrapper.find("[data-uid='" + uid + "']");
            listBox.select(item);
        }
    }

    render() {
        return (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridRow: "15px 1fr" }} >
                <label style={{ gridRow: "1/2", gridColumn: "1/2" }}>{Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.OptContainers")}</label>
                <select id={this.availableListBoxId} style={{ gridRow: "2/3", gridColumn: "1/2", width: "100%" }} ref={(ref) => { this.availableListBoxRef = ref }} />
                <label style={{ gridRow: "1/2", gridColumn: "2/3" }}>{Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.selectedContainers")}</label>
                <select id={this.selectedListBoxId} style={{ gridRow: "2/3", gridColumn: "2/3", width: "100%" }} ref={(ref) => { this.selectedListBoxRef = ref }} />
            </div>
        );
    }
}